import { render, staticRenderFns } from "./mobile-header-default.vue?vue&type=template&id=842c837a&scoped=true"
import script from "./mobile-header-default.vue?vue&type=script&lang=js"
export * from "./mobile-header-default.vue?vue&type=script&lang=js"
import style0 from "./mobile-header-default.vue?vue&type=style&index=0&id=842c837a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842c837a",
  null
  
)

export default component.exports